// pylee/apps/web/app/(home)/components/navbar.tsx
'use client'
import { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Menu, X } from 'lucide-react';
import styles from './navbar.module.css';

const Navbar = () => {
  const pathname = usePathname();
  const isHomePage = pathname === '/';
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Determine the base URL for links
  const getLink = (sectionId: string) => {
    return isHomePage ? `#${sectionId}` : `/#${sectionId}`;
  };  

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className={styles.navbar} id="main-navbar">
      <div className={`page-container ${styles.navContainer}`}>
        {/* Logo */}
        <Link href="/" className={styles.logo}>
          PYLEE<span>AI</span>
        </Link>

        {/* Mobile-only signup button that's always visible */}
        <a 
          href="https://app.pyleeai.com/signup?utm_source=website&utm_medium=nav&utm_campaign=mobile_signup" 
          className={styles.mobileSignupButton}
        >
          Sign up
        </a>

        {/* Mobile menu toggle button */}
        <button 
          className={styles.mobileMenuToggle} 
          onClick={toggleMobileMenu}
          aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Navigation and auth container */}
        <div className={`${styles.navContent} ${mobileMenuOpen ? styles.showMobile : ''}`}>
          {/* Main navigation links */}
          <div className={styles.navLinks}>
            <a href={getLink("compatibility")} onClick={() => setMobileMenuOpen(false)} data-event="navigation" data-event-item="how_it_works">
              How It Works
            </a>
            <a href={getLink("features")} onClick={() => setMobileMenuOpen(false)} data-event="navigation" data-event-item="features">
              Features
            </a>
            <a href={getLink("use-cases")} onClick={() => setMobileMenuOpen(false)} data-event="navigation" data-event-item="use_cases">
              Use Cases
            </a>
            {/* <Link href="/pricing" onClick={() => setMobileMenuOpen(false)}>
              Pricing
            </Link> */}
            <Link href="/blog"
                data-event="navigation"
                data-event-item="blog" 
                onClick={() => setMobileMenuOpen(false)}>
              Blog
            </Link>
            <a 
              href="https://docs.pyleeai.com/" 
              target="_blank" 
              rel="noopener noreferrer"
              data-event="navigation"
              data-event-item="docs"
              onClick={() => setMobileMenuOpen(false)}
            >
              Docs
            </a>
          </div>

          {/* Auth buttons */}
          <div className={styles.authButtons}>
            <a 
              href="https://app.pyleeai.com/sign-in" 
              className={styles.loginButton}
              data-event="login"
              data-event-location="navbar"              
            >
              Log in
            </a>
            
            {/* Desktop signup button (hidden on mobile) */}
            <a 
              href="https://app.pyleeai.com/sign-up?utm_source=website&utm_medium=nav&utm_campaign=signup" 
              className={styles.desktopSignupButton}
              data-event="sign_up"
              data-event-location="navbar"
            >
              Sign up
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;